import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { LoaderService } from '../../service/loader.service';
import { ItButtonDirective, ItCheckboxComponent } from 'design-angular-kit';
import { UtentiApplicativiService } from './utenti-applicativi.service';
import { Subscription } from 'rxjs';
import { UnitaOrganizzativa } from '../../interfaces/unita-organizzativa.interface';
import { UtenteApplicativo } from '../../interfaces/utente-provisioning.interface';
import { AnagraficaEnte } from '../../interfaces/anagrafica-ente.interface';
import { AppService } from '../../service/app.service';
import { CustomValidator } from '../../shared/validators/custom.validator';

@Component({
  standalone: true,
  selector: 'app-associazione-uo',
  templateUrl: './associazione-uo.component.html',
  imports: [
    CommonModule, ItCheckboxComponent, ReactiveFormsModule, ItButtonDirective,
  ],
  providers: [CustomValidator]
})

export class AssociazioneUoComponent implements OnInit {
  ente: AnagraficaEnte = {};
  private _element!: UtenteApplicativo;
  @Input() set element(value: UtenteApplicativo) {
    this._element = value;
    this.form.reset();
    if (this._element.idUtenteApplicativo) {
      this.bindingUO();
    }
  }
  get element() {
    return this._element;
  }
  @Input() uoList: any;

  private _editable = true;
  @Input() set editable(value: boolean) {
    this._editable = value;
    this.disableForm();
  }
  get editable() {
    return this._editable;
  }

  @Input() set reset(value: boolean) {
    this.form.reset();
    this.form.markAsUntouched();
  }
  @Input() set editMode(value: boolean) {
    this.bindingUO();
  }
  @Output() uoListChange = new EventEmitter<any>();

  disableForm() {
    if (!this.editable) {
      this.form.disable({ emitEvent: false });
    } else {
      this.form.enable({ emitEvent: false });
    }
  }

  form: FormGroup = this.fb.group({});
  pageSubscription = new Subscription();

  constructor(
    private loader: LoaderService,
    private fb: FormBuilder,
    private utentiApplicativiService: UtentiApplicativiService,
    private appService: AppService,
    private customValidator: CustomValidator,
  ) { }

  ngOnInit(): void {
    this.ente = this.appService.ente;
    this.createFormUO();
  }

  bindingUO(): void {
    this.element.unitaOrganizzative.forEach((uo: UnitaOrganizzativa) => {
      const controlName = `uo-${uo.idUnitaOrganizzativa}`;
      this.form.get(controlName)?.setValue(true);
    });
  }

  createFormUO(): void {
    this.uoList.forEach((uo: UnitaOrganizzativa) => {
      const controlName = `uo-${uo.idUnitaOrganizzativa}`;
      this.form.addControl(controlName, new FormControl(false));
    });
    this.form.setValidators(this.customValidator.atLeastOneCheckboxCheckedValidator(this.form));
  }

  submit(): void {
    if (this.form.invalid) {
      return;
    }

    const uoList: UnitaOrganizzativa[] = [];
    Object.keys(this.form.controls).forEach((key: string) => {
      if (this.form.get(key)?.value) {
        const uoId = +key.split('-')[1];
        uoList.push(this.uoList.find((uo: UnitaOrganizzativa) => uo.idUnitaOrganizzativa === uoId));
      }
    });
    this.element.unitaOrganizzative = uoList;
    this.element.isBozza = true;
    this.loader.show();
    this.pageSubscription.add(
      this.utentiApplicativiService.post(this.element).subscribe({
        next: (el: any) => {
          if (el) {
            this.uoListChange.emit(el);
          }
        },
        error: () => this.loader.hide(),
        complete: () => this.loader.hide(),
      })
    );
  }

  ngOnDestroy(): void {
    this.pageSubscription.unsubscribe();
  }

}
